import * as api from "../api";
import axios from "axios";
let base = api.BaseApiUrl;
export const getMemberAccountRecords = (params) => {
  return axios.get(`${base}/member`, { params: params });
};
export const getMemberInfo = (params) => {
  return axios.get(`${base}/member/detail`, { params: params });
};

export const getListMembers = (params) => {
  return axios.get(`${base}/api/CardHolder/GetCardHolderDataList`, {
    params: params,
  });
};

export const getCardHolderDetail = (params) => {
  return axios.get(`${base}/api/CardHolder/GetCardHolderDetail`, {
    params: params,
  });
};

export const getRechargeRecordList = (params) => {
  return axios.get(`${base}/api/CardHolder/GetRechargeRecordList`, {
    params: params,
  });
};

export const getWriteOffList = (params) => {
  return axios.get(`${base}/api/CardHolder/GetWriteOffList`, {
    params: params,
  });
};

export const deductCardAmount = (params) => {
  return axios.post(
    `${base}/api/CardHolder/PostAdminUpdateVerification`,
    params
  );
};
